import { render, staticRenderFns } from "./SmallLeftCard.vue?vue&type=template&id=284bf0b1&"
import script from "./SmallLeftCard.vue?vue&type=script&lang=js&"
export * from "./SmallLeftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports